export const onAddModel = () => ({
  widget: 'models',
  type: 'onAddModel',
  payload: {},
})



// WEBPACK FOOTER //
// ./src/models/actions/onAddModel.js